import { useEffect, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch } from "react-redux";
import { actions } from "redux-store";
import { useCurrentMerchantId, useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) => ({
  chartContainer: {
    width: "100%",
    height: 400,
  },
}));

const useMerchantStats = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();
  const dispatch = useDispatch();
  const merchantId = useCurrentMerchantId();

  useEffect(() => {
    dispatch(
      actions.getStatsMerchantsDevicesByMerchantId.request({
        merchantId,
      }),
    );
    dispatch(
      actions.getStatsMerchantsDevicesInfosByMerchantId.request({
        merchantId,
      }),
    );
  }, [dispatch, merchantId]);

  return {
    styles,
    classes,
    atomicStyles,
    t,
  };
};

export { useMerchantStats as default };
